/* AMERICAN BARBELL — Forge homepage behaviours (reveal, marquees, depth) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // reveal on scroll
  var revealEls = document.querySelectorAll('.fg-reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  // duplicate marquee tracks once for a seamless -50% loop
  ['fg-ltrack', 'fg-gtrack'].forEach(function (cls) {
    document.querySelectorAll('.' + cls).forEach(function (track) {
      if (!track.dataset.fgDuped) { track.innerHTML += track.innerHTML; track.dataset.fgDuped = '1'; }
    });
  });

  // installations depth: the card crossing the viewport centre scales up, lifts and brightens
  var gtrack = document.querySelector('.fg-gtrack');
  if (gtrack && !reduce) {
    var cards = Array.prototype.slice.call(gtrack.children);
    var frame = function () {
      var vw = window.innerWidth, cx = vw / 2;
      cards.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.right < -100 || r.left > vw + 100) return;
        var d = Math.min(Math.abs(r.left + r.width / 2 - cx) / cx, 1);
        el.style.transform = 'translateY(' + (16 * d) + 'px) scale(' + (1.07 - 0.13 * d) + ')';
        el.style.opacity = 1 - 0.45 * d;
      });
      window.requestAnimationFrame(frame);
    };
    window.requestAnimationFrame(frame);
  }
})();
